import { render } from "./OperationButtons.vue?vue&type=template&id=475b6dd8"
import script from "./OperationButtons.vue?vue&type=script&lang=js"
export * from "./OperationButtons.vue?vue&type=script&lang=js"
script.render = render

export default script